import { experiences } from '../data/experince';
import Education from './Education';
import Experience from './Experience';

function Resume() {
	const firstTwoExp = experiences.slice(0, 2);

	return (
		<div id="resume" className="max-w-screen-2xl h-fit mx-auto my-auto scroll-mt-36">
			<h2 className="w-11/12 mx-auto mb-10 text-center text-2xl xs:text-3xl sm:text-5xl font-bold">
				Experience
			</h2>
			<Experience experiences={firstTwoExp} root={'root'} />
			<Education />
		</div>
	);
}

export default Resume;
